async function init() {
  const lsPrefersOldBrowser = localStorage.getItem('prefersOldBrowser') === 'true';
  const urlParams = new URLSearchParams(window.location.search);
  const urlParamOverridePrefersOldBrowser = urlParams.get('prefersOldBrowser') === 'true';

  if (!lsPrefersOldBrowser && !urlParamOverridePrefersOldBrowser) {
    localStorage.setItem('prefersOldBrowser', 'false');

    const { ConsoleLogger } = await import('@nx/logger');
    const { MODAL_TYPE, useAppSelector, useConnectionStatus, useModal } = await import('@nx/state');
    const { GuideSidebar, Notifications, frameworkInit } = await import('@nx/ui');
    const { WorkspaceModals } = await import('@nx/workspace-layout');

    const { QueryProvider } = await import('./nx-entry/nx-provider');
    const { QueryApp } = await import('./nx-entry/nx-view');

    const usePasswordChangeModal = () => {
      const { areCredentialsExpired } = useConnectionStatus();
      const passwordChangeModal = useModal(MODAL_TYPE.PASSWORD_CHANGE);

      if (areCredentialsExpired && !passwordChangeModal.isOpen) {
        passwordChangeModal.open({ passwordChangeRequired: true });
      }
    };

    // We'd like to get rid of the wrapper, since we don't need a router
    // but that requires moving url param handling, modals, expired credentials handling
    // to redux (where they arguably belong). This is the least we can get away with for now
    const MinimalBasicQueryWrapper = () => {
      usePasswordChangeModal();
      const showGuidesSidebar = useAppSelector((store) => store.sidebar.guidesIsOpen);

      return (
        <QueryProvider>
          <GuideSidebar open={showGuidesSidebar} />
          <WorkspaceModals />
          <Notifications />
          <QueryApp />
        </QueryProvider>
      );
    };

    void frameworkInit(<MinimalBasicQueryWrapper />, {
      appManifest: {
        name: 'query',
        version: import.meta.env.VITE_APP_VERSION,
      },
      logger: new ConsoleLogger('query'),
      configuration: {
        windowTitle: 'Neo4j Browser',
        basePath: '/',
        fallbackRoute: '/',
        ssoRedirectPath: '/',
        tools: {
          query: {
            displayName: 'Query',
            route: '/',
          },
        },
        sentry: {
          dsn: import.meta.env.VITE_SENTRY_DSN,
          appVersion: import.meta.env.VITE_APP_VERSION,
        },
        segment: {
          apiKey: import.meta.env.VITE_SEGMENT_API_KEY,
          eventPrefix: 'QRY',
        },
      },
      capabilities: {
        'framework:connection-bar': true,
        'framework:connection-bar-show-version': true,
        'framework:connection-history': true,
        'framework:http-query-api': true,
        'framework:respect-dbms-neo4j-conf-settings': true,
        'framework:sso-db-connection': true,
        'framework:theme-switcher': true,
        'framework:filter-sentry-events-on-error-boundary': true,
        'query:custom-guides': true,
        'query:enabled': true,
        'query:open-modal-on-missing-connection': true,
        'query:settings-on-sidebar': true,
        'query:offline-guides': true,
        'query:bundled': true,
        'query:welcome-frame': true,
      },
    });
  }
}

void init();
